import { render, staticRenderFns } from "./SeguimientoInfraccionView.vue?vue&type=template&id=b451a59a&"
import script from "./SeguimientoInfraccionView.vue?vue&type=script&lang=js&"
export * from "./SeguimientoInfraccionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports